// Module
var code = "<md-toast md-theme=\"{{ toast.theme }}\" ng-class=\"{'md-capsule': toast.capsule}\" class=\"sb-toast loading\"> <span flex translate=\"{{toast.content}}\" translate-values=\"{{toast.contentValues}}\"></span> <md-progress-circular class=\"sb-toast-progress\" md-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular> </md-toast> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/toast/loadingToast.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;